var React = require('react');

function BackgroundLines (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.15"},[React.createElement("path",{"d":"M1 0.5V5574.5","stroke":"#162154","strokeDasharray":"8 8","key":0}),React.createElement("path",{"d":"M261 0.5V5574.5","stroke":"#162154","strokeDasharray":"8 8","key":1}),React.createElement("path",{"d":"M521 0.5V5574.5","stroke":"#162154","strokeDasharray":"8 8","key":2}),React.createElement("path",{"d":"M781 0.5V5574.5","stroke":"#162154","strokeDasharray":"8 8","key":3}),React.createElement("path",{"d":"M1041 0.5V5574.5","stroke":"#162154","strokeDasharray":"8 8","key":4})]));
}

BackgroundLines.defaultProps = {"width":"1042","height":"5575","viewBox":"0 0 1042 5575","fill":"none"};

module.exports = BackgroundLines;

BackgroundLines.default = BackgroundLines;
